import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { loggedIn } from "../../api/jwt";

// UI
import { Header, Button, Container } from "../../ui";

class NotFoundPage extends Component {
  state = {
    title: "Страница не найдена"
  };

  render() {
    const isLoggedIn = loggedIn();

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>

        <Container fluid className={!isLoggedIn ? "text-center" : ""}>
          <Header size={1} big margin="no-bottom">
            404
          </Header>
          <Header size={3} margin="no-top">
            {this.state.title}
          </Header>

          <Button
            type="as"
            as={Link}
            to={!isLoggedIn ? "/" : "/dashboard"}
            size="xl"
            theme="primary"
          >
            На главную
          </Button>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  enterprise: state.enterprise,
  shop: state.shop
});

export default connect(mapStateToProps)(NotFoundPage);
